export default __webpack_public_path__ + "static/media/bnbLogo.8a9541fa.svg";